import { render, staticRenderFns } from "./accordion-item.vue?vue&type=template&id=22f2112e&scoped=true"
import script from "./accordion-item.vue?vue&type=script&lang=js"
export * from "./accordion-item.vue?vue&type=script&lang=js"
import style0 from "./accordion-item.vue?vue&type=style&index=0&id=22f2112e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f2112e",
  null
  
)

export default component.exports